import { Component, OnInit } from '@angular/core';
import { ConstantService } from '../../../providers/constants';

@Component({
  selector: 'app-course-comparison-neet',
  templateUrl: './course-comparison-neet.component.html',
  styleUrls: ['./course-comparison-neet.component.scss']
})

export class CourseComparisonNeetComponent implements OnInit{

  tableData:any[]=[];

  showModelContent:boolean = false;

  constructor(public constantsService: ConstantService){}

  ngOnInit(): void {
    this.tableData = this.constantsService.courseComparisonneet;
  }


}
